import * as types from './mutation_types';

export default {
  [types.TRAINER_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.TRAINER_RESET_ERROR](state) {
    Object.assign(state, {
      error: null
    });
  },

  [types.TRAINER_RESET](state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      items: [],
      item: null,
      ownTrainer: null,
      pvpMatches: [],
      pvpRankedList: [],
      infoMessages: [],
      userLoading: false,
      user: {},
    });
  },

  [types.TRAINER_SET_LOADING](state, loading) {
    Object.assign(state, { isLoading: loading });
  },

  [types.TRAINER_SET_ITEMS](state, items) {
    Object.assign(state, { items: items });
  },

  [types.TRAINER_SET_ITEM](state, item) {
    Object.assign(state, { item: item });
  },

  [types.TRAINER_SET_OWN_TRAINER](state, ownTrainer) {
    Object.assign(state, { ownTrainer: ownTrainer });
  },

  // "Patch" vetev bez extra requestu (viz pokemon/POKEMON_PATCH_ITEM) -
  // dungeon/boj apod. odpovidaji jen s journey.position.trainer, ne s
  // timhle samostatnym ownTrainer slotem, takze bez tohohle zustaval
  // pocitadlo pokeballu/masterballu v TeamBottomSheet.vue na hodnote z
  // prihlaseni az do reloadu (nacita se jinak jen jednou, viz trainerId
  // watcher v TeamBottomSheet.vue).
  [types.TRAINER_PATCH_OWN_TRAINER_BALLS](state, trainer) {
    if (!state.ownTrainer) {
      return;
    }
    Object.assign(state.ownTrainer, {
      pokeballs: trainer.pokeballs,
      masterballs: trainer.masterballs,
    });
  },

  [types.TRAINER_SET_PVP_MATCHES](state, pvpMatches) {
    Object.assign(state, { pvpMatches });
  },

  [types.TRAINER_SET_PVP_RANKED_LIST](state, pvpRankedList) {
    Object.assign(state, { pvpRankedList });
  },

  [types.TRAINER_SET_INFO_MESSAGES](state, infoMessages) {
    Object.assign(state, { infoMessages: infoMessages });
  },

  [types.USER_SET_USER](state, user) {
    Object.assign(state, { user: user });
  },

  [types.USER_SET_LOADING](state, userLoading) {
    Object.assign(state, { userLoading: userLoading });
  },
};
